import { $ } from "@/plug/Axios";

export default {
  /**
   * 年度招生考核活动
   */
  assessActivity: {
    /*
     * 添加
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * startTime 开始时间 (string query )
     * year 年度 (string query )
     */
    post: (p, c) => $.post("/api/bms/activity/assessActivity", p, c),

    /*
     * 删除-指标量大于0不可删
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/assessActivity", p, c)
  },
  assessActivity_downloadMould: {
    /*
     * 下载配置代报合同部门模板
     */
    get: (p, c) => $.get("/api/bms/activity/assessActivity/downloadMould", p, c)
  },
  assessActivity_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/activity/assessActivity/list", p, c)
  },
  assessActivity_listAdminEnrollDept: {
    /*
     * 已配置的代报合同部门信息
     */
    get: (p, c) =>
      $.get("/api/bms/activity/assessActivity/listAdminEnrollDept", p, c)
  },
  assessActivity_listMyEnrollDept: {
    /*
     * 根据adminId查询可以选择的代报合同部门-代报用
     * adminId id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/activity/assessActivity/listMyEnrollDept", p, c)
  },
  assessActivity_listName: {
    /*
     * 活动名称下拉列表
     */
    get: (p, c) => $.get("/api/bms/activity/assessActivity/listName", p, c)
  },
  assessActivity_listSimple: {
    /*
     * 简易活动下拉列表
     */
    get: (p, c) => $.get("/api/bms/activity/assessActivity/listSimple", p, c)
  },
  assessActivity_removeEnrollDept: {
    /*
     * 删除配置的代报合同部门, 注意, 如果amdinId不传, 会删除全部
     * adminId adminId (integer query )
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/assessActivity/removeEnrollDept", p, c)
  },
  assessActivity_saveEnrollDept: {
    /*
     * 添加代报合同部门-代报选择用
     * adminId id (integer query required)
     * departmentIds id (array query required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/assessActivity/saveEnrollDept", p, c)
  },
  assessActivity_uploadEnrollDept: {
    /*
     * 导入代报合同部门
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/assessActivity/uploadEnrollDept", p, c)
  },

  /**
   * 年度招生考核部门
   */
  assessDepartment: {
    /*
     * 添加
     * assessActivityId 活动ID (integer query )
     * assessAdminIds 考核人 (string query )
     * businessDepartmentId 事业部id (integer query )
     * department 考核部门 (string query )
     * departmentIds 具体部门id (string query )
     * id  (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/assessDepartment", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/assessDepartment", p, c)
  },
  assessDepartment_assessStatisticsInfo: {
    /*
     * 考核通知展示页面信息-业务助手
     * adminId adminId (string query required)
     * refresh 是否刷新缓存 (boolean query )
     */
    get: (p, c) =>
      $.get("/api/bms/activity/assessDepartment/assessStatisticsInfo", p, c)
  },
  assessDepartment_downloadMould: {
    /*
     * 下载指标导入模板
     */
    get: (p, c) =>
      $.get("/api/bms/activity/assessDepartment/downloadMould", p, c)
  },
  assessDepartment_getPageType: {
    /*
     * 根据adminId查询负责的考核模块
     * adminId adminId (integer query required)
     */
    get: (p, c) => $.get("/api/bms/activity/assessDepartment/getPageType", p, c)
  },
  assessDepartment_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/activity/assessDepartment/list", p, c)
  },
  assessDepartment_listSimpleAssessor: {
    /*
     * 简易考核人下拉列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/assessDepartment/listSimpleAssessor", p, c)
  },
  assessDepartment_saveDepartments: {
    /*
     * 保存部门或考核人
     * id id (integer query required)
     * ids 选择的部门id或管理员id,多个半角逗号隔开 (string query required)
     * type 类型 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/activity/assessDepartment/saveDepartments", p, c)
  },
  assessDepartment_sendNotice: {
    /*
     * 发送钉钉通知,考核通知展示页面信息
     * adminIds 发送目标adminId (array query required)
     * assessorAdminId 哪个考核人的页面 (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/assessDepartment/sendNotice", p, c)
  },
  assessDepartment_upload: {
    /*
     * upload
     * activityId 活动ID (integer query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/activity/assessDepartment/upload", p, c)
  },

  /**
   * 年度招生考核指标
   */
  assessTarget: {
    /*
     * 编辑, 只能编辑系数和指标量
     * assessDepartmentId 部门 (integer query )
     * businessDepartmentId  (integer query )
     * category 分类(招生指标|报到指标) (string query )
     * coefficient 系数 (number query )
     * finalTargetCount  (number query )
     * finishCount 完成量 (integer query )
     * id  (integer query )
     * month 月 (integer query )
     * product 产品 (string query )
     * siteTypes 包含学校类型 (string query )
     * targetCount 指标量 (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/assessTarget", p, c)
  },
  assessTarget_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/activity/assessTarget/export", p, c)
  },
  assessTarget_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/activity/assessTarget/list", p, c)
  },

  /**
   * 职教招生活动
   */
  continueEnrollActivity: {
    /*
     * 添加
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 活动名称 (string query )
     * robotToken 播报机器人token (string query )
     * siteTypes 学校类型 (string query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/bms/activity/continueEnrollActivity", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/continueEnrollActivity", p, c)
  },
  continueEnrollActivity_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/activity/continueEnrollActivity/list", p, c)
  },
  continueEnrollActivity_listCurrent: {
    /*
     * 当前活动
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivity/listCurrent", p, c)
  },
  continueEnrollActivity_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivity/listSimple", p, c)
  },

  /**
   * 职教招生活动奖励
   */
  continueEnrollActivityAwards: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * amount 奖励金额 (number query )
     * id  (integer query )
     * maxNum 最大数量 (integer query )
     * usedNum 已使用数量 (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/continueEnrollActivityAwards", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/continueEnrollActivityAwards", p, c)
  },
  continueEnrollActivityAwards_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityAwards/list", p, c)
  },
  continueEnrollActivityAwards_listForActivityId: {
    /*
     * 根据活动id获取列表
     * activityId activityId (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/continueEnrollActivityAwards/listForActivityId",
        p,
        c
      )
  },

  /**
   * 职教招生活动奖励记录
   */
  continueEnrollActivityAwardsRecord_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityAwardsRecord/export", p, c)
  },
  continueEnrollActivityAwardsRecord_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityAwardsRecord/list", p, c)
  },
  continueEnrollActivityAwardsRecord_lottery: {
    /*
     * 抽奖
     * activityId activityId (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/activity/continueEnrollActivityAwardsRecord/lottery",
        p,
        c
      )
  },
  continueEnrollActivityAwardsRecord_lotteryForOther: {
    /*
     * 抽奖(其他)
     * activityId activityId (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/activity/continueEnrollActivityAwardsRecord/lotteryForOther",
        p,
        c
      )
  },
  continueEnrollActivityAwardsRecord_lotteryTimes: {
    /*
     * 剩余抽奖次数
     * activityId activityId (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/continueEnrollActivityAwardsRecord/lotteryTimes",
        p,
        c
      )
  },
  continueEnrollActivityAwardsRecord_lotteryTimesForOther: {
    /*
     * 剩余抽奖次数（其他）
     * activityId activityId (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/continueEnrollActivityAwardsRecord/lotteryTimesForOther",
        p,
        c
      )
  },

  /**
   * 职教招生活动抽奖名单
   */
  continueEnrollActivityTable: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * adminId 管理员id (integer query )
     * id  (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/continueEnrollActivityTable", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/continueEnrollActivityTable", p, c)
  },
  continueEnrollActivityTable_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityTable/export", p, c)
  },
  continueEnrollActivityTable_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityTable/list", p, c)
  },
  continueEnrollActivityTable_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/continueEnrollActivityTable/upload", p, c)
  },

  /**
   * 职教招生活动目标
   */
  continueEnrollActivityTarget: {
    /*
     * 添加
     * activityId 活动id (integer query )
     * deptIds 部门id (string query )
     * enrollNum 招生人数 (integer query )
     * enrollTarget 招生目标 (integer query )
     * id  (integer query )
     * name 名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/continueEnrollActivityTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/continueEnrollActivityTarget", p, c)
  },
  continueEnrollActivityTarget_getDepartmentIds: {
    /*
     * 获取部门id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/continueEnrollActivityTarget/getDepartmentIds",
        p,
        c
      )
  },
  continueEnrollActivityTarget_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/continueEnrollActivityTarget/list", p, c)
  },
  continueEnrollActivityTarget_refresh: {
    /*
     * 刷新
     * activityId activityId (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/activity/continueEnrollActivityTarget/refresh", p, c)
  },
  continueEnrollActivityTarget_setDepartmentIds: {
    /*
     * 设置部门id
     * departmentIds 部门id (array query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/bms/activity/continueEnrollActivityTarget/setDepartmentIds",
        p,
        c
      )
  },

  /**
   * 2024双十一活动
   */
  doubleElevenActivity: {
    /*
     * 添加
     * adultTargetCount 成教指标 (integer query )
     * armyAdultTargetAmount 中军成教指标|列表||| (number query )
     * armyTogFinishAmount 中军TOG完成量|列表||| (number query )
     * armyTogTargetAmount 中军TOG指标|列表||| (number query )
     * baseSelfTaughtFinishCount 自考基础完成量|列表||| (integer query )
     * businessDepartmentId 事业部 (integer query )
     * continueTargetCount 继教院指标 (integer query )
     * departmentIds 包含的部门 (string query )
     * displayName 显示部门名称 (string query )
     * exemptionTargetAmount 免试专升本指标|列表||| (number query )
     * id  (integer query )
     * selfTaughtTargetCount 自考指标 (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/doubleElevenActivity", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/doubleElevenActivity", p, c)
  },
  doubleElevenActivity_broadcastEnrollByImage: {
    /*
     * 上传图片服务器临时发送到群
     * localFilePath localFilePath (string query )
     * remoteUrl 七牛url (string query )
     * type 类型：学历|继教院|免试专升本业绩 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/activity/doubleElevenActivity/broadcastEnrollByImage",
        p,
        c
      )
  },
  doubleElevenActivity_getPageExportForAdult: {
    /*
     * 成教大屏统计导出页面
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/doubleElevenActivity/getPageExportForAdult",
        p,
        c
      )
  },
  doubleElevenActivity_getPageExportForArmy: {
    /*
     * 退役军人大屏统计导出页面
     */
    get: (p, c) =>
      $.get("/api/bms/activity/doubleElevenActivity/getPageExportForArmy", p, c)
  },
  doubleElevenActivity_getPageExportForContinue: {
    /*
     * 职教大屏统计导出页面
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/doubleElevenActivity/getPageExportForContinue",
        p,
        c
      )
  },
  doubleElevenActivity_getPageForAdult: {
    /*
     * 成教大屏视图
     */
    get: (p, c) =>
      $.get("/api/bms/activity/doubleElevenActivity/getPageForAdult", p, c)
  },
  doubleElevenActivity_getPageForArmy: {
    /*
     * 退役军人大屏视图
     */
    get: (p, c) =>
      $.get("/api/bms/activity/doubleElevenActivity/getPageForArmy", p, c)
  },
  doubleElevenActivity_getPageForContinue: {
    /*
     * 职教大屏视图
     */
    get: (p, c) =>
      $.get("/api/bms/activity/doubleElevenActivity/getPageForContinue", p, c)
  },
  doubleElevenActivity_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/activity/doubleElevenActivity/list", p, c)
  },

  /**
   * 成教招生活动
   */
  enroll: {
    /*
     * 添加
     * baseImageUrl 底图（本地路径 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 活动名称 (string query )
     * robotToken 播报机器人token (string query )
     * siteTypes 学校类型 (string query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/bms/activity/enroll", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/enroll", p, c)
  },
  enroll_downloadMouldForMember: {
    /*
     * 下载导入人员模板
     */
    get: (p, c) =>
      $.get("/api/bms/activity/enroll/downloadMouldForMember", p, c)
  },
  enroll_downloadMouldForTeam: {
    /*
     * 下载导入队伍模板
     */
    get: (p, c) => $.get("/api/bms/activity/enroll/downloadMouldForTeam", p, c)
  },
  enroll_getContinueEnrollActivityForPage: {
    /*
     * 大屏展示-职教招生活动
     */
    get: (p, c) =>
      $.get("/api/bms/activity/enroll/getContinueEnrollActivityForPage", p, c)
  },
  enroll_getEnrollActivityForPage: {
    /*
     * 大屏展示-成教招生活动
     */
    get: (p, c) =>
      $.get("/api/bms/activity/enroll/getEnrollActivityForPage", p, c)
  },
  enroll_list: {
    /*
     * 活动列表
     */
    get: (p, c) => $.get("/api/bms/activity/enroll/list", p, c)
  },
  enroll_listMember: {
    /*
     * 成员列表列表
     * teamId 队伍列表返回id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/activity/enroll/listMember", p, c)
  },
  enroll_listSimple: {
    /*
     * 简易活动列表
     */
    get: (p, c) => $.get("/api/bms/activity/enroll/listSimple", p, c)
  },
  enroll_listTeam: {
    /*
     * 队伍列表
     */
    get: (p, c) => $.get("/api/bms/activity/enroll/listTeam", p, c)
  },
  enroll_removeMember: {
    /*
     * 删除成员
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/enroll/removeMember", p, c)
  },
  enroll_removeTeam: {
    /*
     * 删除队伍
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/enroll/removeTeam", p, c)
  },
  enroll_saveTeam: {
    /*
     * 添加队伍
     * activityId 活动ID (integer query )
     * id  (integer query )
     * leaderId 组长ID (integer query )
     * name 队伍名字 (string query )
     * targetCount 目标单量 (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/enroll/saveTeam", p, c)
  },
  enroll_testBroadcast: {
    /*
     * 测试群播报
     */
    post: (p, c) => $.post("/api/bms/activity/enroll/testBroadcast", p, c)
  },
  enroll_uploadMember: {
    /*
     * 导入成员
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/activity/enroll/uploadMember", p, c)
  },
  enroll_uploadTeam: {
    /*
     * 导入队伍
     * activityId 活动列表id (integer query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/activity/enroll/uploadTeam", p, c)
  },

  /**
   * 免试专升本线索统计配置
   */
  exemptionDegreeClueStatistics: {
    /*
     * 添加
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * proRegisterCount 预计报道量 (integer query )
     * registerCount 报到量 (integer query )
     * wechatCount 加V量 (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/exemptionDegreeClueStatistics", p, c)
  },
  exemptionDegreeClueStatistics_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/export", p, c)
  },
  exemptionDegreeClueStatistics_list: {
    /*
     * 活动列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/list", p, c)
  },
  exemptionDegreeClueStatistics_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics/upload", p, c)
  },

  /**
   * 服务部招生指标
   */
  serviceEnrollTarget: {
    /*
     * 添加
     * adminId adminId (integer query )
     * category 分类:服务部|成教学习规划部 (string query )
     * id  (integer query )
     * month 月 (integer query )
     * target 指标 (integer query )
     * year 年 (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/serviceEnrollTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/serviceEnrollTarget", p, c)
  },
  serviceEnrollTarget_export: {
    /*
     * 导出-基础平台-招生管理-服务部招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/serviceEnrollTarget/export", p, c)
  },
  serviceEnrollTarget_exportForSales: {
    /*
     * 导出-基础平台-招生管理-学习规划部招生指标
     */
    get: (p, c) =>
      $.get("/api/bms/activity/serviceEnrollTarget/exportForSales", p, c)
  },
  serviceEnrollTarget_getStatisticsPageByMonth: {
    /*
     * 服务部汇报数据-总览
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/serviceEnrollTarget/getStatisticsPageByMonth",
        p,
        c
      )
  },
  serviceEnrollTarget_getStatisticsPageForSalesByMonth: {
    /*
     * 成教学习规划部汇报数据-总览
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/serviceEnrollTarget/getStatisticsPageForSalesByMonth",
        p,
        c
      )
  },
  serviceEnrollTarget_list: {
    /*
     * 列表-基础平台-招生管理-服务部招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/serviceEnrollTarget/list", p, c)
  },
  serviceEnrollTarget_listForSales: {
    /*
     * 列表-基础平台-招生管理-学习规划部招生指标
     */
    get: (p, c) =>
      $.get("/api/bms/activity/serviceEnrollTarget/listForSales", p, c)
  },
  serviceEnrollTarget_upload: {
    /*
     * 导入指标
     * category 分类：服务部|成教学习规划部 (string query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/activity/serviceEnrollTarget/upload", p, c)
  }
};
